__turbopack_context__.v({
  "box": "markdown-module__Ng3HmW__box",
  "prose": "markdown-module__Ng3HmW__prose",
  "reference": "markdown-module__Ng3HmW__reference",
  "referenceUnnamed": "markdown-module__Ng3HmW__referenceUnnamed",
  "table": "markdown-module__Ng3HmW__table",
  "task": "markdown-module__Ng3HmW__task",
});
